module.exports = __webpack_public_path__ + "img/EC.0e3003b7.png";